export const getModalSelector = type => state => state.modal[type];
